var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.51 0.76 20.98 20.98"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.32 6.801h-.979c-.964 0-1.264.637-1.264 1.29v1.547h2.153l-.345 2.386h-1.809v5.766a7.361 7.361 0 01-2.426 0v-5.766H7.68V9.638h1.97V7.82c0-2.069 1.159-3.21 2.933-3.21.849 0 1.737.16 1.737.16v2.031zm2.624-6.04H5.056A4.545 4.545 0 00.51 5.306v11.887a4.545 4.545 0 004.545 4.546h11.888a4.545 4.545 0 004.545-4.546V5.306A4.545 4.545 0 0016.944.76z",
    fill: "#1877F2"
  })));
}

export default SvgIconSnsFacebook;